<template>
  <v-menu
    flat
    offset-y
    transition="slide-y-transition"
    :close-on-content-click="false"
    v-model="menu"
    full-width
    min-width="280"
  >
    <v-btn slot="activator" flat color="grey darken-3">
      <v-icon left>search</v-icon>
      Search
    </v-btn>
    <v-card>
      <v-toolbar color="white" class="elevation-0">
        <span class="title">Bot Logs Search</span>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form" v-model="formValid" @submit.prevent="submit()">
          <v-text-field
            v-model="form.requestId"
            label="Request ID"
            :rules="formRules.seek('requestId').getRules()"
            required
          ></v-text-field>
          <v-text-field
            v-model="form.date"
            label="Date"
            type="datetime-local"
            step="1"
            :hint="'Searching on time between ' + getTime(form.date, -DEFAULT_SEARCH_HOUR_RANGE) + ' to ' + getTime(form.date, DEFAULT_SEARCH_HOUR_RANGE)"
            :rules="formRules.seek('date').getRules()"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">Close</v-btn>
        <v-btn color="primary" flat @click="submit" :disabled="loading" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import { parseFormInputValue, escape } from '../../libs/utils'
  import { getTableRules, createFilterableObject } from '../../libs/mongo-datatable'
  import { createMongooseSchema } from '../../services/mongo-connector.service'
  import * as CloudWatch from '../../services/cloudwatch.service'
  import moment from 'moment'

  const DEFAULT_SEARCH_HOUR_RANGE = CloudWatch.DEFAULT_SEARCH_HOUR_RANGE

  export default {
    data () {
      const form = {
        requestId: null,
        date: parseFormInputValue(Date, +moment.utc().add(-DEFAULT_SEARCH_HOUR_RANGE, 'hours'))
      }
      return {
        DEFAULT_SEARCH_HOUR_RANGE,
        loading: false,
        menu: false,
        form,
        formValid: true,
        formRules: getTableRules(
          form,
          createMongooseSchema({
            requestId: {
              type: String,
              required: true,
              validate: {
                validator (value) {
                  return /^\s*[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4,12}\s*$/i.test(value)
                },
                message: 'Please enter correct "Request ID" format'
              }
            },
            date: { type: Date, required: true }
          })
        )
      }
    },
    methods: {
      getTime (time, hours) {
        return moment.utc(time).add(hours, 'hours').format('HH:mm')
      },
      close () {
        this.menu = false
      },
      async submit () {
        const valid = this.$refs.form.validate()
        console.log('formValid', valid)
        if (!this.loading && valid) {
          this.loading = true
          await this.search({
            requestId: this.form.requestId.trim(),
            date: this.form.date
          })
          this.loading = false
        }
      },
      async search ({ requestId, date }) {
        const { message } = await CloudWatch.search({ requestId, date })
        if (this.menu) {
          await CloudWatch.showResult({ requestId, message })
        }
      }
    }
  }
</script>
